import React from 'react';
import invariant from 'invariant';
import { Icon } from 'antd';
import { IconProps } from 'antd/lib/icon';

// https://www.iconfont.cn
const DokIcon = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1807242_kxwazfnkinl.js',
});

export default (props: IconProps) => {
  const { type, style, className } = props;

  invariant(type, 'Icon 的 type 不能为空');

  return <DokIcon style={style} type={`d-${type}`} className={className} />;
};
